import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';

import ErnResponseForm from '../molecules/ErnResponseForm';
import PleaseCallUs from '../molecules/PleaseCallUs';
import UnexpectedError from '../molecules/UnexpectedError';
import ErnCapturedConfirmation from '../molecules/ErnCapturedConfirmation';

import { useJWTPayload, useErnResponseSubmit, isPayloadValid } from './utils';

const ErnCaptureForm = () => {
  const [jwt, payload] = useJWTPayload();
  const {
    handleSubmit, register, watch, setValue, setError,
    formState, errors,
  } = useForm({
    defaultValues: {
      customerHaveErn: true,
      taxOfficeCode: '',
      taxOfficeEmployerReference: '',
      exemptionReason: '',
    },
    shouldUnregister: false,
  });
  const { onSubmit } = useErnResponseSubmit(jwt, setError);

  if (!jwt || !isPayloadValid(payload)) {
    return <PleaseCallUs />;
  }

  if (formState.isSubmitted) {
    if (formState.isSubmitSuccessful) {
      return <ErnCapturedConfirmation />;
    }
    if (errors.submit) {
      return <UnexpectedError />;
    }
  }

  return (
    <FormProvider
      register={register}
      watch={watch}
      setValue={setValue}
      errors={errors}
      formState={formState}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <ErnResponseForm policyNumber={payload.policy_display_number} />
      </form>
    </FormProvider>
  );
};

export default ErnCaptureForm;
